/* eslint-disable */
import {
    greenThemeLight, greenThemeDark, bwThemeLight, bwThemeDark, blueThemeLight, blueThemeDark, redThemeLight, redThemeDark, orangeThemeLight, orangeThemeDark, purpleThemeLight, purpleThemeDark, pinkThemeLight, pinkThemeDark, beigeThemeLight, beigeThemeDark, beigeThemewhite, beigeThemeoffwhite, beigeThemeWhite, beigeThemeOffwhite
} from '../theme/theme'


export const themeData = {
    theme: beigeThemeWhite
}


// Choose theme from above